import { render, staticRenderFns } from "./UltimateShareSidePanel.vue?vue&type=template&id=2cd17a44&"
import script from "./UltimateShareSidePanel.vue?vue&type=script&lang=ts&"
export * from "./UltimateShareSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports